import { render, staticRenderFns } from "./Caraibes.vue?vue&type=template&id=db88e5c2&"
import script from "./Caraibes.vue?vue&type=script&lang=js&"
export * from "./Caraibes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports